import { useState, useEffect } from "react";
import { router } from "@inertiajs/react";

export function usePagination(collection, pageSlug) {
    const caseStudies = Array.isArray(collection?.data) ? collection.data : [];

    const [filteredCards, setFilteredCards] = useState(caseStudies);
    const [localCollection, setLocalCollection] = useState(null);

    useEffect(() => {
        if (collection) {
            setFilteredCards(caseStudies);
            setLocalCollection(collection);
        }
    }, [caseStudies, collection]);

    const handleLoadMore = (newData, newPagination) => {
        if (!Array.isArray(newData)) return;

        setFilteredCards((previous) => [
            ...(Array.isArray(previous) ? previous : []),
            ...newData,
        ]);

        setLocalCollection((prev) => {
            if (!prev) return null;
            return {
                ...prev,
                data: [
                    ...(Array.isArray(prev.data) ? prev.data : []),
                    ...newData,
                ],
                meta: {
                    ...prev.meta,
                    current_page: (prev.meta?.current_page || 1) + 1,
                },
            };
        });
    };

    const handlePageChange = (pageNumber) => {
        // Reset local collection when navigating via pagination
        // to avoid conflicts with load more's incremental page tracking
        setLocalCollection(null);
        setFilteredCards([]);

        router.get(
            route("frontend.page", pageSlug),
            { page: pageNumber },
            {
                preserveScroll: false,
                onSuccess: () =>
                    window.scrollTo({ top: 0, behavior: "smooth" }),
            },
        );
    };

    return {
        filteredCards,
        localCollection,
        handleLoadMore,
        handlePageChange,
    };
}
